import BaseAction from "./BaseAction";
import CustomerReviewReducer from "@common/redux/reducers/CustomerReviewReducer";

class CustomerReviewAction extends BaseAction {
  open = async () => {
    this.dispatch({ open: true });
  };

  close = this.reset;
}

const action = new CustomerReviewAction(CustomerReviewReducer);
export default action;
